var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import parse from "html-react-parser";
import get from "lodash/get";
import { connect } from '../../store/connect';
import { getResponseManager, ResponseTypeEnum } from "../../responseManager/BeeResponseManager";
import { FORM_DESCRIPTION } from "../../classConstants";
import { getInitialData } from "../../store/actions/response.actions";
var bookcartDescriptionFactory = function () {
    var mapStateToFormBody = function (state) {
        var initialData = getInitialData(state.responseReducer).response;
        return { initialData: initialData };
    };
    var mergePropsFormBody = function (_a) {
        var initialData = _a.initialData;
        var options = initialData && getResponseManager(initialData).getResponseData(ResponseTypeEnum.OPTIONS);
        return {
            bookDescription: get(options || {}, "book", ""),
        };
    };
    return connect(mapStateToFormBody, null, mergePropsFormBody)(function (props) {
        return React.createElement(FormBody, { className: FORM_DESCRIPTION }, parse(props.bookDescription));
    });
};
export var BookingCartDescription = bookcartDescriptionFactory();
var FormBody = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
